export default __webpack_public_path__ + "static/media/1781.bc07a657.png";